import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, s, ui } from '../styles/theme'
import { useIsMobile } from '../hooks/useViewport'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

function tarih(v) {
  if (!v) return '—'
  try { return new Date(v).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' }) }
  catch (e) { return '—' }
}

function boyut(n) {
  const k = Number(n) || 0
  return k < 1024 ? k + ' B' : (k / 1024).toFixed(1).replace('.', ',') + ' KB'
}

export default function IcerikBloklari() {
  const { selectedBrand } = useBrand()
  const mobil = useIsMobile()
  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  const [bloklar, setBloklar] = useState([])
  const [yukleniyor, setYukleniyor] = useState(false)
  const [islemde, setIslemde] = useState(null)
  const [msg, setMsg] = useState(null)

  function flash(text, ok = true) { setMsg({ text, ok }); setTimeout(() => setMsg(null), 3500) }

  function getir() {
    if (!selectedBrand) { setBloklar([]); return }
    setYukleniyor(true)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/icerik-bloklari`, { headers })
      .then(res => setBloklar(res.data.bloklar || []))
      .catch(() => setBloklar([]))
      .finally(() => setYukleniyor(false))
  }

  useEffect(getir, [selectedBrand?.id]) // eslint-disable-line

  function durumDegistir(b) {
    if (!selectedBrand || islemde) return
    const yeni = b.durum === 'yayin' ? 'onizleme' : 'yayin'
    setIslemde(b.product_id + '-' + b.surum)
    axios.put(
      `${API}/admin/brands/${selectedBrand.id}/icerik-bloklari/${encodeURIComponent(b.product_id)}/durum`,
      { durum: yeni, surum: b.surum },
      { headers }
    )
      .then(() => {
        flash(yeni === 'yayin' ? 'İçerik yayına alındı' : 'İçerik yayından kaldırıldı')
        getir()
      })
      .catch(() => flash('Durum değiştirilemedi', false))
      .finally(() => setIslemde(null))
  }

  const yayindaSayisi = bloklar.filter(b => b.durum === 'yayin').length

  return (
    <div>
      {msg && <div style={{ ...(msg.ok ? s.alertSuccess : s.alertDanger), marginBottom: '16px' }}>{msg.text}</div>}

      <div style={{ ...s.cardFlat, padding: '14px 16px', marginBottom: '16px' }}>
        <div style={{ fontSize: '13px', color: colors.textSecondary, lineHeight: 1.6 }}>
          Bu listedeki içerikler ürün sayfasına <b style={{ color: colors.textPrimary }}>ürün açıklaması değiştirilmeden</b> eklenir.
          Yayına aldığınızda ziyaretçiler görür, kaldırdığınızda ürün sayfası eski haline döner.
          Her ürün için aynı anda yalnızca bir sürüm yayında olabilir.
        </div>
      </div>

      {!selectedBrand && <div style={ui.emptyText}>Önce bir marka seçin.</div>}

      {selectedBrand && yukleniyor && <div style={ui.emptyText}>Yükleniyor…</div>}

      {selectedBrand && !yukleniyor && bloklar.length === 0 && (
        <div style={ui.emptyText}>Bu marka için hazırlanmış içerik bloğu yok.</div>
      )}

      {selectedBrand && !yukleniyor && bloklar.length > 0 && (
        <>
          <div style={{ fontSize: '13px', color: colors.textSecondary, marginBottom: '10px' }}>
            {bloklar.length} içerik · {yayindaSayisi} tanesi yayında
          </div>

          <div style={{ display: 'grid', gap: '10px' }}>
            {bloklar.map(b => {
              const yayinda = b.durum === 'yayin'
              const bekliyor = islemde === b.product_id + '-' + b.surum
              return (
                <div
                  key={b.product_id + '-' + b.surum}
                  style={{
                    ...s.cardFlat,
                    padding: '14px 16px',
                    display: 'flex',
                    alignItems: mobil ? 'flex-start' : 'center',
                    flexDirection: mobil ? 'column' : 'row',
                    gap: mobil ? '12px' : '16px'
                  }}
                >
                  {b.image_url && (
                    <img
                      src={b.image_url}
                      alt=""
                      width="52"
                      height="52"
                      style={{ width: '52px', height: '52px', objectFit: 'contain', flex: '0 0 auto', background: colors.bgPage }}
                    />
                  )}

                  <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                    <div style={{ fontSize: '14px', fontWeight: 600, color: colors.textPrimary, marginBottom: '3px' }}>
                      {b.name || 'Ürün bulunamadı'}
                    </div>
                    <div style={{ fontSize: '12px', color: colors.textSecondary }}>
                      {b.product_code ? b.product_code + ' · ' : ''}
                      Ürün no {b.product_id}
                      {b.surum > 1 ? ' · Sürüm ' + b.surum : ''}
                      {' · ' + boyut(b.boyut)}
                      {' · ' + tarih(b.updated_at)}
                    </div>
                    {b.is_active === false && (
                      <div style={{ fontSize: '12px', color: colors.warningText, marginTop: '3px' }}>
                        Ürün sitede pasif görünüyor
                      </div>
                    )}
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: '0 0 auto' }}>
                    <span style={yayinda ? ui.chipStrong : ui.chip}>{yayinda ? 'Yayında' : 'Yayında değil'}</span>

                    {b.product_url && (
                      <a
                        href={b.product_url + (b.product_url.indexOf('?') === -1 ? '?' : '&') + 'onizleme=' + b.surum}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...ui.btnQuiet, textDecoration: 'none' }}
                      >
                        Önizle
                      </a>
                    )}

                    <button
                      type="button"
                      style={yayinda ? ui.btnDangerQuiet : ui.btnPrimarySm}
                      disabled={bekliyor}
                      onClick={() => durumDegistir(b)}
                    >
                      {bekliyor ? '…' : (yayinda ? 'Yayından kaldır' : 'Yayına al')}
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        </>
      )}
    </div>
  )
}
